module.exports = __webpack_public_path__ + "img/avi_logo.9b86be5d.png";